// cf. src/components/BuiltWith.js

import React from "react"
import AmbassadorCard from "images/vertical_black_card_2.webp";

const BuiltRow = ({ k, v, alt }) => (
  <div
    style={
      alt
        ? {
            background:
              "linear-gradient(to right, #fff, rgba(147,252,229,0.3))",
          }
        : {}
    }
  >
    <div className="inline-block w-3/5 pl-8 pr-2 font-bold align-middle">
      {k}
    </div>
    <div className="inline-block w-2/5 pr-8 pl-2 py-6 whitespace-nowrap align-middle">
      {v}
    </div>
  </div>
);

const YourCardAmbassador = () => (
  <div className="bg-white text-black pt-10">
    <div className="max-w-page">
      <div className="xl:w-5/6 px-5 xl:px-0 mx-auto py-10 flex justify-between items-center flex-col md:flex-row">

        <div className="md:mr-5 md:max-w-1/2">
          <img className="max-w-full" style={{width: '400px'}} src={AmbassadorCard} />
        </div>

        <div className="w-0 h-0 hidden md:block relative z-20" style={{border: '20px solid transparent', borderRight: '20px solid white'}} />

        <div className="flex-1 md:pb-8 self-stretch">
          <h2 className="text-3xl md:text-4xl font-extrabold p-8 pt-0 text-center md:text-left">Your card<span className="text-primary">.</span></h2>

          <div className="w-0 h-0 md:hidden relative z-20 mx-auto" style={{border: '20px solid transparent', borderBottom: '20px solid white'}} />

          <div className="md:text-lg lg:text-xl rounded-lg shadow-faint w-full md:w-auto md:my-0">
            <BuiltRow k="Spending power" v="$100-$10,000" alt />
            <BuiltRow k="Interest rate (APR)" v="None" />
            <BuiltRow k="Cashback" v="Up to 20%" alt />
          </div>
        </div>

      </div>
    </div>
  </div>
);

export default YourCardAmbassador;
